<template lang="pug">
HelloWorld
</template>

<script setup>
import HelloWorld from './HelloWorld.vue';
</script>
